import { MODAL_ALERT } from '../lib/types';

const initialState = {
    text: "",
    toggle: false,
    btnText: "",
    productType: "",
    secondButton: { show: false, text: "" },
    showAsHtml: false,
    addClassName: null,
    overrideTextAlign: false,
};

export default (state = initialState, action) => {
  /* discriminate the action type */
    switch (action.type) {
        case MODAL_ALERT:
            return {
                ...state,
                text: action.payload.text,
                toggle: action.payload.toggle,
                btnText: action.payload.btnText,
                productType: action.payload.productType,
                secondButton: action.payload.secondButton,
                showAsHtml: action.payload.showAsHtml,
                addClassName: action.payload.addClassName,
                overrideTextAlign: action.payload.overrideTextAlign,
            };
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/modal-alert.reducer.js